export const DOCUMENT_SEARCH_START_LOADING = "DOCUMENT_SEARCH_START_LOADING";
export const DOCUMENT_SEARCH_END_LOADING = "DOCUMENT_SEARCH_END_LOADING";
export const DOCUMENT_SEARCH_LOADED = "DOCUMENT_SEARCH_LOADED";
export const SET_DOCUMENT_FILTER = "SET_DOCUMENT_FILTER";

export const DOCUMENT_START_DOWNLOADING = "DOCUMENT_START_DOWNLOADING";
export const DOCUMENT_END_DOWNLOADING = "DOCUMENT_END_DOWNLOADING";